import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { Box, Typography } from '..';
import TypeaheadSelect from '../Typeahead/TypeaheadSelect';
import TypeaheadMultiSelect from '../TypeaheadMultiSelect';
import { LoadingIndicator } from './select.style';
import Label from '../Label';
const getValues = value => {
  if (!value.length) return [];
  return value.map(v => {
    var _a;
    if (typeof v === 'string') {
      return v;
    } else if (v.options && ((_a = v.options) === null || _a === void 0 ? void 0 : _a.length) > 0) {
      return getValues(v.options);
    } else {
      return v.value;
    }
  }).flat();
};
const Select = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      variant = 'default',
      disabled = false,
      hiddenlabel = false,
      placeholder,
      name,
      id,
      label,
      hintText,
      loading,
      options,
      errorMessage,
      invalid,
      value,
      orientation = 'vertical',
      fit = 'medium',
      onChange
    } = props,
    restProps = __rest(props, ["variant", "disabled", "hiddenlabel", "placeholder", "name", "id", "label", "hintText", "loading", "options", "errorMessage", "invalid", "value", "orientation", "fit", "onChange"]);
  const values = value ? getValues(value) : [''];
  const isMultiple = variant === 'multiple';
  const selectValue = !isMultiple && values[0] || '';
  const onChangeMultipleSelect = values => {
    if (onChange) {
      if (Array.isArray(values)) {
        const item = values.slice(-1)[0];
        onChange({
          target: {
            value: (item === null || item === void 0 ? void 0 : item.value) || ''
          }
        });
      }
    }
  };
  const onChangeSingleSelect = item => {
    if (onChange) {
      onChange({
        target: {
          value: (item === null || item === void 0 ? void 0 : item.value) || ''
        }
      });
    }
  };
  const selectVariant = variant;
  const selectOptions = useMemo(() => {
    if (!options || !options.length) return [];
    return options.map(option => {
      const value = typeof option !== 'string' ? option.value : option;
      const label = typeof option !== 'string' ? option.label : option;
      return {
        id: value.toLowerCase(),
        label: label,
        value: value
      };
    });
  }, [options]);
  return _jsxs(Box, _extends({
    display: "flex",
    alignItems: orientation === 'vertical' ? 'unset' : 'center',
    flexDirection: orientation === 'vertical' ? 'column' : 'row'
  }, {
    children: [!hiddenlabel && label && _jsx(Label, _extends({
      fit: fit,
      id: id,
      label: label,
      orientation: orientation
    }, restProps)), _jsxs(Box, _extends({
      flex: "1",
      position: "relative"
    }, {
      children: [isMultiple ? _jsx(TypeaheadMultiSelect, _extends({
        placeholder: placeholder,
        id: id,
        renderValue: 'value',
        fit: fit,
        options: selectOptions,
        suggestType: "static",
        onChange: onChangeMultipleSelect
      }, restProps)) : _jsx(TypeaheadSelect, _extends({
        variant: selectVariant,
        name: name,
        id: id,
        disabled: disabled,
        error: invalid,
        value: selectValue || '',
        fit: fit,
        placeholder: placeholder,
        onSuggestionSelect: onChangeSingleSelect,
        ref: ref,
        options: selectOptions,
        readOnly: true,
        clearButton: false,
        select: true
      }, restProps)), loading && _jsx(LoadingIndicator, _extends({
        fit: fit
      }, {
        children: _jsxs("svg", _extends({
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 100 100"
        }, {
          children: [_jsx("circle", {
            className: "track",
            cx: "50",
            cy: "50",
            fill: "none",
            r: "40"
          }), _jsx("circle", {
            className: "spinner",
            cx: "50",
            cy: "50",
            fill: "none",
            r: "40",
            strokeDasharray: "55 200"
          })]
        }))
      }))]
    })), invalid && errorMessage && _jsx(Box, _extends({
      mt: 4,
      color: "feedback.danger.normal"
    }, {
      children: _jsx(Typography, _extends({
        variant: "body2",
        fontStyle: "normal"
      }, {
        children: errorMessage
      }))
    })), hintText && _jsx(Box, _extends({
      mt: 4,
      color: "functional.grey.700"
    }, {
      children: _jsx(Typography, _extends({
        variant: "body2",
        fontStyle: "normal"
      }, {
        children: hintText
      }))
    }))]
  }));
});
export default Select;